import Badge from "@material-ui/core/Badge"
import styled from "styled-components"

export default styled(Badge)`
  .MuiBadge-badge {
    position: relative;
  }
`
